var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconScore548Line = function SvgIconScore548Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.299c-9.21 0-16.7 7.49-16.7 16.7 0 9.21 7.49 16.7 16.7 16.7 9.21 0 16.7-7.49 16.7-16.7 0-9.21-7.49-16.7-16.7-16.7Zm0 30c-7.33 0-13.3-5.97-13.3-13.3 0-7.33 5.97-13.3 13.3-13.3 7.33 0 13.3 5.97 13.3 13.3 0 7.33-5.97 13.3-13.3 13.3Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 26.199H18c-.5 0-.98.22-1.3.6-.32.38-.46.89-.38 1.38.63 3.72 3.86 6.41 7.68 6.41s7.04-2.7 7.68-6.41c.08-.49-.05-1-.38-1.38-.32-.38-.8-.6-1.3-.6ZM17.7 20.399c0-.44.36-.8.8-.8.44 0 .8.36.8.8v2h3.4v-2a4.2 4.2 0 1 0-8.4 0v2h3.4v-2ZM29.5 16.199a4.2 4.2 0 0 0-4.2 4.2v2h3.4v-2c0-.44.36-.8.8-.8.44 0 .8.36.8.8v2h3.4v-2a4.2 4.2 0 0 0-4.2-4.2Z",
    fill: "current"
  })));
};
export default SvgIconScore548Line;